"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoCall/segments/VideoSetupGroup.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// Video setup section, used to tweak user's video settings.
var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);




var _videoCall = require('web/selectors/videoCall');
var _hooks = require('web/services/hooks');

var _Video = require('web/components/VideoCall/Setup/SetupGroups/Video'); var _Video2 = _interopRequireDefault(_Video);
var _useSetupStream = require('./useSetupStream');





// Was a class inside connect(): memo keeps connect's props bail-out.
const VideoSetupGroupContainer = ({ onUserProblemPublish }) => {
  const videoInDevices = _hooks.useAppSelector.call(void 0, _videoCall.selectVideoInDevices)
  const currentCamDeviceId = _hooks.useAppSelector.call(void 0, _videoCall.selectCurrentCamDeviceId)
  // Not rendered, but connect() subscribed to it, so a change re-renders the
  // group as before.
  _hooks.useAppSelector.call(void 0, _videoCall.selectAreCamIssuesPresent)

  const stream = _useSetupStream.useSetupStream.call(void 0, 'cam', currentCamDeviceId, onUserProblemPublish)

  return (
    _react2.default.createElement(_Video2.default, {
      videoStream: stream,
      videoInDevices: videoInDevices,
      currentCamDeviceId: currentCamDeviceId,
      setCurrentCamDeviceId: _actions2.default.setCurrentCamDeviceId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
    )
  )
}

exports. default = _react.memo.call(void 0, VideoSetupGroupContainer)
